import {Box} from '@wix/design-system'
import {useStyles} from '@wix/tpa-settings/react'
import {getEventId} from '@wix/wix-events-commons-statics'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../../../../stylesParams'
import s from './day-events.scss'
import {EventInfo} from './event-info'
import {DayEventsProps} from './interfaces'

export const DayEvents = ({events, currentDate}: DayEventsProps) => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const {get} = useStyles()

  const eventsPerCalendarCell = get(stylesParams.eventsPerCalendarCell)

  return isMobile ? (
    <div className={s.eventDot} />
  ) : (
    <>
      <div className={s.container}>
        {events.slice(0, eventsPerCalendarCell).map((event, index) => (
          <Box key={getEventId(event)} marginTop={index ? '4px' : 0}>
            <EventInfo event={event} currentDate={currentDate} />
          </Box>
        ))}
        {events.length > eventsPerCalendarCell && (
          <div className={s.more}>
            {t('layout.calendar.monthly.events.moreLink', {amount: events.length - eventsPerCalendarCell})}
          </div>
        )}
      </div>
      <div className={classNames(s.eventDot, s.eventDotVisibility)} />
    </>
  )
}
